import store from '@/store';

export default {
    PreorderIsRequiredButItHasNotBeenGiven(routeTo) {
        let preorderRequired = routeTo.matched.find(m => m.meta.preorderRequired);
        if (!preorderRequired)
            return false;

        return preorderRequired.meta.preorderRequired && 
                store.state.preorder.IsLoaded == false;
    },

    StopNavigationAndRedirectToMainPage(to, next) {
        next(false); // Cancela a navegação

        if (to.name == 'MainPage') return;

        next({ name: 'MainPage', query: { id: to.query.id } });
    }
};